import { Alert, AlertIcon, AlertTitle, Button, Grid, Stack, Text } from '@chakra-ui/react'

import { usePartner } from '@/context/PartnerContext'
import { useApp } from '@/hooks/useApp'
import { LoginForm } from 'BrokerTsLib/src/containers'
import { useLogin, useSsoLogin } from 'BrokerTsLib/src/hooks'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export interface LoginProps { returnUrl?: string, error?: boolean }

export const Login = ({ returnUrl, error }: LoginProps) => {
  const { mutateAsync } = useLogin()

  return (
    <Grid sx={{ gap: 4, justifyContent: 'center' }}>
      <LoginForm returnUrl={returnUrl} login={mutateAsync} forgotPasswordUrl='/auth/reset-password' />

      <SSOButtons returnUrl={returnUrl} error={error} />

      {error && <Alert status="error" fontSize="sm" variant="solid">
        <AlertIcon boxSize="1.5em" mr={4} />
        <AlertTitle>
          Do aplikace nemáte přístup.<br /> Obraťte se na Vaši podporu.
        </AlertTitle>
      </Alert>}
    </Grid>
  )
}

export const SSOButtons = ({ returnUrl, error }: LoginProps) => {
  const { currentPartner } = usePartner()

  // Až se bude někdy přidávat další SSO provider, tak by to chtělo předělat buď od settingů partnera nebo získávat z API.
  const ssoProviders = currentPartner?.partner === 'Kapitol' ? [{
    providerName: 'Kapitol',
    isAutomatic: true
  }] : []

  if (ssoProviders.length === 0)
    return null

  return <>
    <Text sx={{ fontSize: 'sm', textAlign: 'center' }}>nebo</Text>
    <Stack w="full" gap={2} justifyContent={'center'} alignItems={'center'}>
      {ssoProviders.map(provider => (
        <SSOButton key={provider.providerName} provider={provider} returnUrl={returnUrl} error={error} />
      ))}
    </Stack>
  </>
}

const SSOButton = ({ provider, returnUrl, error }: { provider: { providerName: string, isAutomatic: boolean, error?: boolean }, returnUrl?: string, error?: boolean }) => {
  const [isLoading, login] = useSsoLogin(provider.providerName, returnUrl)
  const [params] = useSearchParams()
  const { environment } = useApp()
  const preventAutomatic = params.has('preventAutomatic') || params.has('cebia') || environment === 'development' || error
  // Pokud je v URL parametr preventAutomatic, tak se nepřihlásí automaticky.
  // Používá se to pro případ, že uživatel chce přihlásit jiným účtem než tím SSO.
  // V praxi to znamená, že pokud je tento parametr v URL, tak se tlačítko SSO nezapne samo.

  useEffect(() => {
    if (provider.isAutomatic && !preventAutomatic)
      login()
  }, [provider.isAutomatic, login, preventAutomatic])

  return (
    <Button
      colorScheme="primary"
      size="lg"
      isLoading={isLoading}
      onClick={() => login()}
      w={{ base: 'full', md: 'auto' }}
    >
      Přihlásit se přes {provider.providerName}
    </Button>
  )
}